/**
 * Hand the browser to another site — Stripe's checkout.
 *
 * One line, behind a module of its own because it is the one place the builder leaves itself
 * for good: a test stands in for it (the test DOM does not navigate), and the Plan screen's
 * paywall can be seen to report InitiateCheckout BEFORE the page goes, not after.
 */
export function leaveFor(url: string): void {
  window.location.assign(url);
}
